import React, { createRef, useEffect, useState } from "react";

import Container from "../Container";
import HamburgerButton from "../HamburgerButton";
import Logo from "../Logo";
import NavbarNav from "../NavbarNav";

export interface NavbarProps {
  hideNav?: boolean;
}

const Navbar = ({ hideNav }: NavbarProps) => {
  // Toggle
  const initialToggle = window.innerWidth >= 1024;
  const [isOpen, setIsOpen] = useState(initialToggle);
  const toggle = () => {
    setIsOpen((curIsOpen) => !curIsOpen);
  };

  // Handle window resize
  useEffect(() => {
    const handleResize = () => setIsOpen(window.innerWidth >= 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Close when click outside
  const ref = createRef<HTMLDivElement>();
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setIsOpen(window.innerWidth >= 1024);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [ref]);

  return (
    <div className="border-b lg:border-none">
      <Container>
        <div
          className="relative z-10 w-full bg-white lg:flex lg:py-4"
          ref={ref}
        >
          <div className="relative z-10 flex flex-wrap items-center justify-between py-6 bg-white lg:py-0">
            <Logo />
            {!hideNav ? (
              <div className="lg:hidden">
                <HamburgerButton isOpen={isOpen} onClick={toggle} />
              </div>
            ) : null}
          </div>
          {!hideNav ? (
            <div className="relative z-0 block w-full">
              <NavbarNav
                isOpen={isOpen}
                onClick={() => setIsOpen(window.innerWidth >= 1024)}
              />
            </div>
          ) : null}
        </div>
      </Container>
    </div>
  );
};

export default Navbar;
